import { Reveal, Eyebrow, PageHero } from "@/components/shared";
import { IMAGES } from "@/data/content";

const facts = [
  ["Born", "3 May 1972, Bengaluru district, Karnataka (as Jagadish)"],
  ["Education", "B.E. in Civil Engineering"],
  ["Ordination", "Full monastic ordination, Bodh Gaya, 2007"],
  ["Role", "General Secretary, IBMCT"],
  ["Padayatra", "30,000+ KM walked for Dhamma and social harmony"],
  ["Outreach", "International Dhamma missions and interfaith dialogue"],
];

const Leadership = () => (
  <>
    <PageHero
      testId="leadership-hero"
      eyebrow="The Monk"
      title="Venerable Bhante Bodhidatta Thera"
      intro="A Buddhist monk dedicated to the Dhamma, to compassion, and to service. General Secretary, International Buddhist Monks Charitable Trust."
    />

    <section className="bg-ivory" data-testid="leadership-profile-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-24 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <Reveal className="lg:col-span-4">
          <img
            src={IMAGES.portrait}
            alt="Portrait of Venerable Bhante Bodhidatta Thera"
            className="rounded-full w-72 h-72 object-cover mx-auto border-4 border-[rgba(118,87,45,0.4)]"
            data-testid="leadership-page-portrait"
          />
          <blockquote className="mt-10 font-serif italic text-xl text-charcoal/90 border-l-2 border-saffron pl-6" data-testid="leadership-page-quote">
            “The path of Dhamma is not walked alone — it is walked for all beings.”
          </blockquote>
        </Reveal>
        <Reveal className="lg:col-span-8" delay={100}>
          <Eyebrow>His Story</Eyebrow>
          <h2 className="text-[32px] sm:text-4xl font-semibold text-charcoal">From Engineer to Monk to Servant of All</h2>
          <p className="mt-6 text-charcoal/80 leading-relaxed">
            Born as Jagadish on 3 May 1972 in Bengaluru district, Karnataka, Venerable Bhante Bodhidatta Thera completed a B.E. in Civil Engineering
            before dedicating his life to the Dhamma and to those at the margins of society. He received full monastic ordination at
            Bodh Gaya in 2007 — the very place of the Buddha’s awakening.
          </p>
          <p className="mt-4 text-charcoal/80 leading-relaxed">
            Since then, he has walked — quite literally — thousands of kilometres across India on padayatra, carrying a message of
            peace, social harmony and compassion. Under his leadership, IBMCT has grown from a local initiative into a registered
            charitable trust with flagship programs in elder care, women’s empowerment, child welfare and rural healthcare, alongside
            the ambitious Nalanda Study Centre, completed in 2024.
          </p>
          <p className="mt-4 text-charcoal/80 leading-relaxed">
            His work has extended to the Sacred Buddha Relic Initiative, advocacy for the protection of the Ashokan Rock Edicts, and
            international Dhamma outreach — always returning to one conviction: that wisdom and compassion belong in action.
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="leadership-facts">
            {facts.map(([k, v]) => (
              <div key={k} className="border border-[rgba(118,87,45,0.45)] rounded-lg p-5 bg-[rgba(245,239,228,0.5)]">
                <p className="font-sans text-[12px] font-bold uppercase tracking-[0.18em] text-earth">{k}</p>
                <p className="mt-2 font-sans font-semibold text-charcoal text-[15px]">{v}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  </>
);

export default Leadership;
